<template>
  <md-dialog :md-active.sync="showTicketDialog" id="ticket-list-dialog">
    <md-dialog-title>Available Tickets</md-dialog-title>
    <md-dialog-content>
      <div class="md-layout">
        <md-table
          id="ticket-availability"
          class="md-layout-item md-size-100"
          v-model="availableTickets"
          :md-height="300"
          @md-selected="onSelect"
        >
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="single"
          >
            <md-table-cell md-label="Type Type">{{ item.title }}</md-table-cell>
            <md-table-cell md-label="Availability">
              {{ item.allocation }}</md-table-cell
            >
            <md-table-cell md-label="Price">
              {{ item.prices[currency] }}
              <small>{{ currency.toUpperCase() }}</small></md-table-cell
            >
          </md-table-row>
        </md-table>
      </div>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary md-dense" @click="$emit('cancelled')"
        >Cancel</md-button
      >
      <md-button
        class="md-primary md-dense"
        @click="selectTicket"
        :disabled="!selectedTicket"
        >Select</md-button
      >
    </md-dialog-actions>
  </md-dialog>
</template>
<script>
import _filter from "lodash/filter";
import booking from "../../services/api/booking";

export default {
  props: ["showTicketDialog", "booking", "traveller", "ticketTypes"],
  data() {
    return {
      selectedTicket: null
    };
  },
  methods: {
    onSelect(item) {
      this.selectedTicket = item;
    },
    selectTicket() {
      this.$emit("ticketSelected", this.traveller, this.selectedTicket);
    }
  },

  computed: {
    availableTickets() {
      let currentTicketId = this.traveller.ticket?.id;
      return _filter(this.ticketTypes, function(ticketType) {
        return ticketType.id !== currentTicketId;
      });
    },
    currency() {
      return this.booking.currency;
    }
  }
};
</script>
<style lang="scss" scoped>
#ticket-list-dialog {
  &::v-deep .md-dialog-container {
    width: 768px;
  }
}

#ticket-availability {
  &::v-deep th:nth-child(1) {
    width: 60%;
  }
  &::v-deep th:nth-child(2),
  &::v-deep th:nth-child(3) {
    width: 20%;
  }
}
</style>
